module.exports = __webpack_public_path__ + "static/media/howtobuy-05.8157b3eb.png";